import React from 'react';

import { AvatarImage } from '@playbooks/ui/components/avatar';
import { Button } from '@playbooks/ui/components/button';
import { FarIcon } from '@playbooks/ui/components/icon';
import { cn } from '@playbooks/ui/lib/utils';

const AccountDropBtn = React.forwardRef(
	(
		{
			account,
			icon = undefined,
			active = false,
			status = null,
			collapsed = false,
			density = 'default',
			showChevron = true,
			className = '',
			...props
		}: any,
		ref: any,
	) => {
		// Theme
		const size = density === 'compact' ? 'sm' : density === 'comfortable' ? 'lg' : 'default';
		const classNames = {
			root: cn(
				'w-full shrink-0 justify-start gap-0 overflow-hidden px-0',
				density === 'compact' ? 'h-8' : density === 'comfortable' ? 'h-10' : 'h-9',
				className,
			),
			name: cn(
				'ml-10 min-w-0 flex-1 overflow-hidden truncate text-left transition-[max-width,opacity] duration-200 ease-out',
				showChevron ? 'mr-7' : 'mr-2',
				collapsed ? 'max-w-0 opacity-0' : 'max-w-full opacity-100',
			),
			icon: cn('absolute right-2 size-3 text-foreground-body', collapsed && 'hidden'),
			status: cn(
				'absolute -top-0.5 -right-0.5 size-2 rounded-full border-2 border-surface-control',
				status === 'warning' && 'bg-warning',
				status === 'danger' && 'bg-danger',
			),
		};

		// Render
		return (
			<Button
				ref={ref}
				type='button'
				variant='outline'
				size={size}
				data-active={active}
				{...props}
				className={classNames.root}>
				<span className='absolute left-2 flex-middle size-6 shrink-0'>
					{icon ? (
						<span className='flex-middle size-6 rounded-full bg-surface-hover text-foreground-body'>
							<FarIcon icon={icon} className='size-3.5' />
						</span>
					) : (
						<AvatarImage className='size-6 shrink-0 rounded-full object-cover' src={account.thumbnail} alt='' />
					)}
					{status ? <span aria-hidden className={classNames.status} /> : null}
				</span>
				<span className={classNames.name}>{account.name}</span>
				{showChevron ? <FarIcon icon='chevron-down' className={classNames.icon} /> : null}
			</Button>
		);
	},
);

AccountDropBtn.displayName = 'AccountDropBtn';

export { AccountDropBtn };
